<script>
import Cleave from "cleave.js";

export default {
  props: {
    value: {
      type: [String, Number],
      required: false,
      default: ""
    },
    raw: { type: Boolean, default: false }
  },
  data() {
    return {
      currentValue: this.value
    };
  },
  mounted() {
    this.cleave = new Cleave(this.$el, {
      time: true,
      timePattern: ["h", "m"],
      onValueChanged: this.onValueChanged.bind(this)
    });

    this.cleave.setRawValue(this.value);
  },
  methods: {
    onValueChanged({ target }) {
      this.$nextTick(() => {
        this.currentValue = target.value;
        this.$emit("input", this.raw ? target.rawValue : this.currentValue);
      });
    }
  }
};
</script>

<template>
  <input
    class="o-input o-input--time"
    :class="{
      'o-input--is-invalid': currentValue.length != 5
    }"
    v-model="currentValue"
  />
</template>
